<!-- 生产加工 - 生产领料单子 - 销售转生产领料(这是个按钮)  菜单代码 11203-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
          <el-form-item label="订单日期：">
            <el-date-picker size="medium" v-model="searchForm.SEND_DAY" type="date" placeholder="选择日期"
              :clearable="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="领料部门：">
            <el-select size="medium" filterable v-model="searchForm.department" style="width: 100%" :clearable="true">
              <el-option v-for="item in departmentList" :key="item.ID" :value="item.ID" :label="item.DEPARTMENT_NAME">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button size="medium" type="primary" :loading="loading" @click="doQueryTable()">筛选</el-button>
        </el-form>
      </el-col>
      <el-col>
        <el-button size="medium" :loading="loading" @click="transferOrder">转换领料单</el-button>
        <!-- <el-button size="small" :loading="loading" @click="addProduct">添加领料产品</el-button> -->
      </el-col>
    </el-row>
    <el-row style="margin-top:20px;">
      <el-col>
        <el-table border stripe :data="tableData" @selection-change="handleSelectionChange"
          :span-method="objectSpanMethod" :header-cell-style="{ textAlign: 'center' }" ref="tableData"
          :cell-style="{ textAlign: 'center' }">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="CP_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="OP_NAME" label="生成产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="ORDER_DATE" label="订单日期"></el-table-column>
          <el-table-column prop="DEPARTMENT_NAME" label="生产部门"></el-table-column>
          <el-table-column prop="MAX_NEED_COUNT" label="需领料总数"></el-table-column>
          <el-table-column prop="WAREHOUSE_COUNT" label="库存数量"></el-table-column>
          <el-table-column prop="BATCH" label="批次"></el-table-column>
          <el-table-column prop="PRODUCTION_DATE" label="生产日期"></el-table-column>
          <el-table-column label="预领料数量" prop="PRE_COUNT">
            <template slot-scope="scope">
              <el-row>
                <el-col :xl="16" :md="24">
                  <el-input v-model="scope.row.PRE_COUNT" :placeholder="scope.row.PRE_COUNT"
                    @focus="getProductCount(scope.row)" @change="$_getCount" @blur="getFee(scope.row)" clearable>
                  </el-input>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="COMMENT">
            <template slot-scope="scope">
              <el-row>
                <el-col :xl="16" :md="24">
                  <el-input v-model="scope.row.COMMENT" :placeholder="scope.row.COMMENT" clearable>
                  </el-input>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 转换模态框 -->
    <el-row>
      <el-col>
        <el-dialog title="转换领料单" center :visible.sync="transferVisible" width="600px">
          <el-form size="small" :model="transferForm" ref="transferForm">
            <el-form-item label="订单日期：" :label-width="formLableWidth">
              <el-date-picker v-model="transferForm.ORDER_DAY" clearable type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd" style="width:80%"></el-date-picker>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="transferVisible = false">取 消</el-button>
            <el-button size="small" @click="transferSubmit">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <!-- 添加领料 -->
    <el-row>
      <el-col>
        <el-dialog title="添加领料产品" center :visible.sync="addProductVisible" width="600px">
          <el-form :inline="true" style="padding-top:0;margin-top:0px" :model="searchDialogForm">
            <el-form-item label="名称：">
              <el-input placeholder="名称" v-model="searchDialogForm.COUNTRY_NAME" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="serchDialog()">筛选</el-button>
            </el-form-item>
          </el-form>
          <el-table stripe border :data="tableDialogData" :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="产品名称" prop="PROJECT_NAME"></el-table-column>
            <el-table-column label="批次" prop="PROJECT_NAME"></el-table-column>
            <el-table-column label="库存" prop="PROJECT_NAME"></el-table-column>
            <el-table-column label="单位" prop="PROJECT_NAME"></el-table-column>
            <el-table-column label="数量" prop="PROJECT_NAME"></el-table-column>
            <el-table-column label="操作" prop="PROJECT_NAME"></el-table-column>
          </el-table>
          <div class="pagination_box">
            <el-pagination @current-change="dialog_handleCurrentChange" :current-page.sync="dialog_currentPage"
              :page-size="dialog_pageSize" layout="total,prev, pager, next, jumper" :total="dialog_total_count">
            </el-pagination>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="addProductVisible = false">取 消</el-button>
            <el-button size="small" @click="addProductSubmit">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <!-- 确定领料 -->
    <el-row>
      <el-col>
        <el-dialog title="填写领料信息" center :visible.sync="determineVisible" width="600px">
          <el-form size="small" :model="determineForm" ref="determineForm">
            <el-form-item label="领料日期：" :label-width="formLableWidth">
              <el-date-picker v-model="determineForm.ORDER_DAY" clearable type="date" placeholder="选择日期"
                value-format="yyyy-MM-dd" style="width:80%"></el-date-picker>
            </el-form-item>
            <el-form-item label="领料人：" :label-width="formLableWidth">
              <el-input style="width:345px" v-model="determineForm.NAME"> </el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="determineVisible = false">取 消</el-button>
            <el-button size="small" @click="determineSubmit">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-dialog title="未配置产品" center :visible.sync="dayVisible" width="800px">
      <el-table :data="beroDay" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="100px;"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="名称"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="内部编码"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="数量"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDay">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="以下产品缺少库存" center :visible.sync="lackVisible" width="800px">
      <el-table :data="lackProduct" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="100px;"></el-table-column>
        <el-table-column prop="CP_NAME" label="名称"></el-table-column>
        <el-table-column prop="CP_CODE" label="产品编码"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeLack">关闭</el-button>
      </div>
    </el-dialog>
    <div class="subWeekOrder">
      <el-button @click="confirmButton">确定领料</el-button>
    </div>
  </div>
</template>
<script>
import { queryInStorageFun } from 'api/warehouseManager';
import { queryDepartment } from 'api/productDepart';
import date from '@/assets/common/date';
import util from '../../assets/common/util';

export default {
  data() {
    return {
      searchForm: {},
      transferForm: {
        ORDER_DAY: '',
      },
      determineForm: {},
      searchDialogForm: {},
      tableData: [],
      beroDay: [],
      lackProduct: [],
      tableDialogData: [],
      addProductForm: [],
      departmentList: [],
      total_count: 0,
      // pageSize: 10,
      count: '',
      // currentPage: 1,
      totalCount: 0,
      pageSize: 30,
      currentPage: 1,
      lackVisible: false,
      dayVisible: false,
      dialog_total_count: 0,
      dialog_pageSize: 10,
      dialog_currentPage: 1,
      transferVisible: false,
      determineVisible: false,
      addProductVisible: false,
      loading: false,
      formLableWidth: '120px',
      spanArr: [],
      PICKING_LIST: [],
      flag: 0,
      INFO_LIST: [],
      meals: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    // if (this.STOCK_IN_CONDITION) {
    //     this.currentPage = this.STOCK_IN_CONDITION.CURRENT_PAGE
    //     this.searchForm = this.STOCK_IN_CONDITION.CONDITION;
    // } else {
    //     this.currentPage = 1
    // }
    this.queryDepartment();
  },
  methods: {
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    doQueryTable() {
      this.currentPage = 1;
      this.queryData();
    },
    // handleCurrentChange(e) {
    //   this.queryData()
    // },
    transferOrder() {
      this.transferVisible = true;
    },
    closeDay() {
      this.dayVisible = false;
    },
    transferSubmit() {
      const params = {
        SERVICE_ID: '10053',
        OTYPE: 16,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.transferForm.ORDER_DAY) {
        params.ORDER_DATE = date(this.transferForm.ORDER_DAY, '%F');
      } else {
        this.$message.show({ text: '请选择日期', type: 'success' });
      }
      this.loading = true;
      queryInStorageFun(params)
        .then((result) => {
          if (result[0].UNTRANSFERD_PRODUCT_LIST.length !== 0) {
            this.$message.show({ text: '以下产品暂未配置', type: 'warning' });
            this.beroDay = result[0].UNTRANSFERD_PRODUCT_LIST;
            this.transferForm.ORDER_DAY = '';
            this.dayVisible = true;
            this.transferVisible = false;
          } else {
            this.$message.show({ text: '转换成功', type: 'success' });
            this.transferForm.ORDER_DAY = '';
            this.transferVisible = false;
          }
          this.loading = false;
        }).catch((error) => {
          this.loading = false;
          this.$message.show({ text: error, type: 'error' });
        });
    },
    addProduct() {
      this.addProductVisible = true;
    },
    addProductSubmit() {
    },
    // 数量改变
    getProductCount(row) {
      this.count = row.PRE_COUNT;
    },
    handleSelectionChange(val) {
      console.log(111);
      console.log(val);
      console.log(this.tableData);
      this.meals = val;
    },
    $_getCount(count) {
      this.count = count;
    },
    getFee(row) {
      // console.log(5555);
      // console.log(this.count);
      row.PRE_COUNT = this.count;
      //  console.log(row);
      if (row.PRE_COUNT == '') {
        row.PRE_COUNT = 0;
      }
      const reg = /[a-zA-Z\u4e00-\u9fa5]/;
      if (reg.test(row.PRE_COUNT)) {
        this.$message.show({ text: '请输入数字', type: 'error' });
        return false;
      }
      if (Number(row.PRE_COUNT) > Number(row.WAREHOUSE_COUNT)) {
        this.$message.show({ text: '领料数量不能大于库存数量', type: 'error' });
      }
      if (util.JudgmentUnit(row.TYPE_UNIT)) { // 如果不是
        console.log('我随便输');
      } else {
        console.log(row.PRE_COUNT, '我在这');
        const beInter = (row.PRE_COUNT % 1 === 0);
        if (beInter == false) {
          this.$message.show({ text: '单位不是KG或斤的，只能输入整数', type: 'error' });
          return false;
        }
      }
    },
    dialog_handleCurrentChange() {
      this.currentPage = 1;
      this.queryData();
    },
    confirmButton() {
      // console.log(11111);
      // console.log(this.meals);
      const arr = [];
      this.determineVisible = true;
      this.meals.forEach((item) => {
        arr.push({
          PRODUCT_CODE: item.CP_CODE,
          PRODUCT_NAME: item.CP_NAME,
          PRODUCT_BATCH: item.BATCH,
          NEED_COUNT: item.PRE_COUNT,
          PRODUCT_COUNT: item.WAREHOUSE_COUNT,
          PRODUCT_PRICE: item.PRODUCT_PRICE,
          DEPARTMENT_NAME: item.DEPARTMENT_NAME,
          PRODUCT_WORTH: item.PRODUCT_WORTH,
          PREPARATIVE_PICKING_ID: item.PREPARATIVE_PICKING_ID,
          DETAIL_ID: item.DETAIL_ID,
          COMMENT: item.COMMENT,
          DEPARTMENT_ID: item.DEPARTMENT_ID,
        });
      });
      this.PICKING_LIST = arr;
      this.PICKING_LIST = this.PICKING_LIST.filter((item) => item.NEED_COUNT !== 0);
      this.INFO_LIST = arr.filter((item) => item.NEED_COUNT == 0);
      console.log(111111111);
      console.log(this.INFO_LIST);
    },
    determineSubmit() {
      const params = {
        SERVICE_ID: '10053',
        OTYPE: 19,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PICKING_LIST: this.PICKING_LIST,
        INFO_LIST: this.INFO_LIST,
      };
      if (this.determineForm.ORDER_DAY) {
        params.PICKING_DATE = date(this.determineForm.ORDER_DAY, '%F');
      } else {
        this.$message.show({ text: '请输入领料日期', type: 'warning' });
        return false;
      }
      if (this.determineForm.NAME) {
        params.REQUISITIONER = this.determineForm.NAME;
      } else {
        this.$message.show({ text: '请输入领料人', type: 'warning' });
        return false;
      }
      this.loading = true;
      queryInStorageFun(params)
        .then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.determineVisible = false;
          this.currentPage = 1;
          this.queryData();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    getSpanArr(data) {
      this.spanArr = [];
      // data就是我们从后台拿到的数据
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          if (data[i].DETAIL_ID == data[i - 1].DETAIL_ID) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
        //  console.log(this.spanArr);
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 2 || columnIndex === 5 || columnIndex === 3 || columnIndex === 4 || columnIndex === 6 || columnIndex === 7) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        //  console.log(`rowspan:${_row} colspan:${_col}`);
        return {
          // [0,0] 表示这一行不显示， [2,1]表示行的合并数
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    closeLack() {
      this.lackVisible = false;
    },
    queryData() {
      const params = {
        SERVICE_ID: '10053',
        OTYPE: 17,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.SEND_DAY) {
        params.ORDER_DATE = date(this.searchForm.SEND_DAY, '%F');
      }
      if (this.searchForm.department) {
        params.DEPARTMENT_ID = this.searchForm.department;
      }
      this.loading = true;
      queryInStorageFun(params)
        .then((result) => {
          if (result[0].LACK_LIST.length !== 0 && this.flag == 0) {
            this.tableData = result[0].PRE_INFO;
            this.lackVisible = true;
            this.lackProduct = result[0].LACK_LIST;
            this.totalCount = result[0].TOTAL_COUNT;
            this.getSpanArr(this.tableData);
            this.flag = 1;
          } else {
            this.tableData = result[0].PRE_INFO;
            this.getSpanArr(this.tableData);
            this.totalCount = result[0].TOTAL_COUNT;
          }
          this.loading = false;
        }).catch((error) => {
          this.loading = false;
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 拉取领料部门
    queryDepartment() {
      queryDepartment().then((res) => {
        this.departmentList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    outWarehouse(scope) {
      this.$router.push({ path: '/stockEnterDetail/detail' });
      sessionStorage.setItem('orderId', scope.row.ORDER_ID);
    },
  },
};
</script>
<style scoped>
  .pagination_box {
    float: left;
    margin-top: 10px;
  }

  .dialog-footer {
    margin-top: 30px;
  }

  .subWeekOrder {
    margin-top: 20px;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/productionProcessing/purchaseProduct.vue